import { render, staticRenderFns } from "./PublishingCompanyEditButton.vue?vue&type=template&id=2d500689"
import script from "./PublishingCompanyEditButton.vue?vue&type=script&lang=js"
export * from "./PublishingCompanyEditButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports